<template>
  <div class="companyPage">
    <div class="company_wrapper">
      <div class="certification_state flex-rowc">
       <i class="iconfont icon-yonghuzhongxin"></i> {{ userCompanyCard.checklabel }}
      </div>
      <div class="company_upper flex-rowl">
        <div class="img_box">
          <van-image :src="userCompanyCard.logo" width="100%" height="100%" />
        </div>
        <div class="intro">
          <div class="row">
            <div class="subTit">企业名称：</div>
            <div class="txt">{{ userCompanyCard.qyname }}</div>
          </div>
          <div class="row">
            <div class="subTit">企业名称英文/缩写：</div>
            <div class="txt">{{ userCompanyCard.qyename }}</div>
          </div>
        </div>
      </div>
      <div class="company_content_info">
        <div class="row flex-rowl" v-if="false">
          <div class="txt">你的角色：</div>
          <div class="right">
            <div class="con"></div>
          </div>
        </div>
        <div class="row flex-rowl">
          <div class="txt">联系人：</div>
          <div class="right">
            <div class="con">
              {{ userCompanyCard.linkname ? userCompanyCard.linkname : "" }}
            </div>
          </div>
        </div>
        <div class="row flex-rowl">
          <div class="txt">联系电话：</div>
          <div class="right flex-between">
            <div class="con">
              {{ userCompanyCard.linkphone ? userCompanyCard.linkphone : "" }}
            </div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.linkphone"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
        <div class="row flex-rowl">
          <div class="txt">联系邮箱：</div>
          <div class="right flex-between">
            <div class="con">
              {{ userCompanyCard.linkemail ? userCompanyCard.linkemail : "" }}
            </div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.linkemail"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
        <div class="row">
          <div class="txt">社会统一信用代码：</div>
          <div class="bottom flex-between">
            <div class="con">
              {{ userCompanyCard.uscc ? userCompanyCard.uscc : "" }}
            </div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.uscc"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
      </div>
      <div class="company_down">
        <div class="row flex-rowl">
          <div class="txt">官方抖音ID：</div>
          <div class="right flex-between">
            <div class="con">
              {{ userCompanyCard.douyinid ? userCompanyCard.douyinid : "" }}
            </div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.douyinid"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
        <div class="row flex-rowl">
          <div class="txt">官方小红书ID：</div>
          <div class="right flex-between">
            <div class="con">
              {{ userCompanyCard.redbookid ? userCompanyCard.redbookid : "" }}
            </div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.redbookid"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
        <div class="row flex-rowl">
          <div class="txt">官方大众点评ID：</div>
          <div class="right flex-between">
            <div class="con">
              {{ userCompanyCard.dianpingid ? userCompanyCard.dianpingid : "" }}
            </div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.dianpingid"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
      </div>
      <div class="company_address">
        <div class="row flex-rowl">
          <div class="txt">所在地区：</div>
          <div class="right flex-between">
            <div class="con" v-if="cityArea">
              {{ cityArea }}
              <!-- {{ userCompanyCard.city }} {{ userCompanyCard.area }} -->
            </div>
            <div class="place" v-else>省、市、自治区</div>
            <div
              class="copy_box"
              :data-clipboard-text="cityArea"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
        <div class="row row_address">
          <div class="txt">详细地址：</div>
          <div class="bottom flex-between">
            <div class="con" v-if="userCompanyCard.addr">
              {{ userCompanyCard.addr }}
            </div>
            <div class="place" v-else>区、街道、详细地址</div>
            <div
              class="copy_box"
              :data-clipboard-text="userCompanyCard.addr"
              @click="handleCopyBtn"
            ><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="operation_wrapper">
      <div v-if="userCompanyCard.checkstate == '审核中'">
        <div class="txt">
          <p>已经申请加入，待审核</p>
          <p>申请时间：{{ userCompanyCard.checkdate }}</p>
        </div>
        <div class="primary-button-plain" @click="handleCancelApply">
          取消加入申请
        </div>
      </div>
      <div v-else-if="userCompanyCard.checkstate == '已通过'">
        <div class="txt">
          <p>已加入</p>
        </div>
        <div class="primary-button-plain" @click="handleExit">退出企业</div>
      </div>
      <div v-else-if="userCompanyCard.checkstate == '拒绝加入'">
        <div class="txt">
          <p>拒绝加入</p>
        </div>
        <div class="primary-button" @click="handleApply">重新申请加入</div>
      </div>
      <div class="primary-button" @click="handleApply" v-else>申请加入</div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import {
  getCompanyInfo,
  applyAddCompany,
  cancelApply,
  userExitCompany,
} from "../../api/company";
export default {
  name: "companyDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      userCompanyCard: {},
      cityArea: "",
    };
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo() {
      let { qyid } = this.$route.params;
      let userInfo = this.$store.state.USERINFO;
      getCompanyInfo({ qyid, openid: userInfo.openid }).then((res) => {
        res.logo = res.logo.indexOf('http') != -1 ? res.logo : this.baseUrl + res.logo
        this.userCompanyCard = res;
        let provincename = res.provincename ? res.provincename : ''
        let cityname = res.cityname ? res.cityname : ''
        let arearname = res.arearname ? res.arearname : ''
        this.cityArea = provincename + cityname + arearname
      });
    },

    // 申请加入
    handleApply() {
      let { userCompanyCard } = this;
      let userInfo = this.$store.state.USERINFO;
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      let params = {
        qyid: userCompanyCard.id,
        accountid: userInfo.accountid,
        openid: userInfo.openid,
        truename: userInfo.truename,
        mobile: userInfo.mobile,
        deptid: "",
        roleid: "",
      };
      applyAddCompany(params).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          toast.clear();
          this.getCompanyInfo();
        } else {
          toast.clear();
          this.$toast.fail(res.message);
        }
      });
    },

    // 取消申请
    handleCancelApply() {
      let { userCompanyCard } = this;
      const toast = this.$toast.loading({
        message: "申请中...",
        forbidClick: true,
      });
      let userInfo = this.$store.state.USERINFO;
      let params = {
        qyid: userCompanyCard.id,
        openid: userInfo.openid,
      };
      cancelApply(params).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          this.getCompanyInfo();
        } else {
          toast.clear();
        }
      });
    },

    // 退出企业
    handleExit() {
      const toast = this.$toast.loading({
        message: "申请中...",
        forbidClick: true,
      });
      let { userCompanyCard, OPENID } = this;
      let params = {
        qyid: userCompanyCard.id,
        openid: OPENID,
      };
      userExitCompany(params).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          this.getCompanyInfo();
        } else {
          toast.clear();
        }
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.companyPage {
  .company_wrapper {
    padding: 50px 35px 30px;
    box-sizing: border-box;
    position: relative;
    font-size: 24px;
    .company_upper {
      .img_box {
        width: 160px;
        height: 160px;
        margin-right: 30px;
      }
      .intro {
        font-size: 24px;
        color: #333333;
        .row:nth-child(1) {
          margin-bottom: 22px;
        }
        .subTit {
          font-size: 20px;
          color: #969696;
          margin-bottom: 10px;
        }
      }
    }
    .company_content_info,
    .company_down,
    .company_address {
      margin: 50px 0 85px;
      .row {
        margin-bottom: 28px;
        &:last-child {
          margin-bottom: 0;
        }
        .right {
          flex: 1;
          flex-shrink: 0;
        }
        .bottom {
          margin-top: 10px;
        }
        .copy_box {
          margin-left: 20px;
          flex-shrink: 0;
        }
        .place {
          width: 100%;
        }
      }
    }
    .certification_state {
      position: absolute;
      top: 15px;
      right: 15px;
      background: #bebebe;
      border-radius: 17px;
      color: #fff;
      font-size: 18px;
      height: 35px;
      line-height: 35px;
      padding: 0 28px 0 21px;
      .iconfont {
        font-size: 28px;
        margin-right: 4px;
      }
    }
    .place {
      font-size: 22px;
      color: #969696;
    }
    .btn {
      position: absolute;
      height: 60px;
      line-height: 60px;
      background: #373737;
      border-radius: 30px;
      font-size: 22px;
      color: #fff;
      padding: 0 45px 0 36px;
      bottom: -20px;
      &.company_edit1 {
        left: 34px;
        &::after {
          display: inline-block;
          content: "";
          background: url(../../assets/images/qy_btn_icon01.png) no-repeat
            center;
          background-size: cover;
          width: 20px;
          height: 20px;
          margin-left: 12px;
        }
      }
      &.company_edit2 {
        left: 354px;
        &::after {
          display: inline-block;
          content: "";
          background: url(../../assets/images/qy_btn_icon02.png) no-repeat
            center;
          background-size: cover;
          width: 23px;
          height: 20px;
          margin-left: 12px;
        }
      }
    }
  }
  .operation_wrapper {
    font-size: 22px;
    text-align: center;
    .txt {
      margin-bottom: 30px;
      p {
        line-height: 45px;
      }
    }
  }
}
</style>